export const organizationSchema = {
	'@context': 'https://schema.org',
	'@type': 'Organization',
	name: 'FishPlace',
	url: 'https://fishplace.ru',
	logo: 'https://fishplace.ru/img/logo.svg',
	telephone: '+7-908-999-80-80',
	email: 'info@fishplace.ru',
	address: {
		'@type': 'PostalAddress',
		addressCountry: 'RU',
	},
	sameAs: ['https://t.me/fishplaceru'],
};

export const breadcrumbSchema = (items: Array<{ name: string; url: string }>) => ({
	'@context': 'https://schema.org',
	'@type': 'BreadcrumbList',
	itemListElement: items.map((item, i) => ({
		'@type': 'ListItem',
		position: i + 1,
		name: item.name,
		item: `https://fishplace.ru${item.url}`,
	})),
});

export const itemListSchema = (
	items: Array<{
		name: string;
		url: string;
		image?: string;
		description?: string;
	}>,
) => ({
	'@context': 'https://schema.org',
	'@type': 'ItemList',
	itemListElement: items.map((item, i) => ({
		'@type': 'ListItem',
		position: i + 1,
		name: item.name,
		url: `https://fishplace.ru${item.url}`,
		...(item.image && { image: item.image }),
		...(item.description && { description: item.description }),
	})),
});

export const graphSchema = (schemas: Array<any>) => ({
	'@context': 'https://schema.org',
	'@graph': schemas,
});
